import { Group, Stack, Text, Title } from "@mantine/core";
import { Badge, Card } from "@xplatform/design-system";
import { useTranslation } from "react-i18next";
import type { PublicReleaseNote } from "@models/releaseNotes";
import { useLocalized } from "@utils/localizedText";
import { ChangeList } from "@components/ChangeList";

interface Props {
  note: PublicReleaseNote;
  /** Hidden when the surrounding list is already grouped by module. */
  showModule?: boolean;
}

export const ReleaseNoteCard = ({ note, showModule = false }: Props) => {
  const { t } = useTranslation();
  const { pick, formatDate } = useLocalized();

  // Card ships the platform surface defaults: border, padding md, radius sm.
  return (
    <Card>
      <Stack gap="md">
        <Stack gap={4}>
          <Group gap="sm" align="center">
            {showModule && (
              <Badge>{t(`releases.module.${note.module}`)}</Badge>
            )}
            <Badge variant="outline" color="gray">
              {note.version}
            </Badge>
            {/* Version and date on every entry, always. */}
            <Text size="sm" c="dimmed">
              {formatDate(note.released_at)}
            </Text>
          </Group>
          <Title order={4}>{pick(note.title)}</Title>
        </Stack>

        {pick(note.highlight) && <Text>{pick(note.highlight)}</Text>}

        {note.changes.length > 0 && <ChangeList changes={note.changes} />}
      </Stack>
    </Card>
  );
};
